<script lang="ts">
  import type { PostCardStoryblok } from "$types/components";
  export let blok: PostCardStoryblok;

  import resizeImage from "$lib/utils/resizeImage";
  import { aspectRatio } from "$lib/utils/optimizeImage";
  import { parseUrl } from "$lib/utils/helpers";
  import ArrowLink from "$lib/atoms/ArrowLink.svelte";
  let isExternalLink = blok?.post?.content?.externalLink?.url?.length > 0;

  const heading =
    blok?.customHeading?.length > 0
      ? blok?.customHeading
      : blok?.post?.content?.previewHeading?.length > 0
        ? blok.post.content.previewHeading
        : blok.post.name;

  const publishDate = Date.parse(blok.post.first_published_at);
  const displayDate = !isNaN(publishDate)
    ? new Date(Date.parse(blok.post.first_published_at ?? "")).toLocaleString(
        "en-us",
        {
          month: "numeric",
          day: "numeric",
          year: "numeric",
        },
      )
    : "";

  const mastheadImage = blok?.post?.content?.mastheadImage ?? blok?.post?.content?.meta[0]?.share_image;
</script>

<a
  href={blok?.post?.content?.externalLink?.url ||
    "/" + parseUrl(blok?.post.full_slug)}
  target={isExternalLink ? "_blank" : ""}
  rel={isExternalLink ? "noopener noreferrer" : ""}
  class="bg-[#F2F1EF] w-full h-full flex flex-col md:flex-row md:p-[1.5rem] md:items-center md:gap-[30px] no-underline group"
>
  <div
    class="flex-1 max-h-full flex flex-col md:justify-around md:pt-0 overflow-hidden rounded-[.25rem]"
  >
    <div class="max-h-full flex-auto md:hidden md:mt-[24px] h-[30%] md:h-[70%]">
      {#if mastheadImage?.filename?.length > 0}
        <div class="h-full">
          <img
            src={resizeImage(
             mastheadImage.filename,
              732,
              572,
            )}
            alt=""
            class="w-full h-full object-cover flex-auto md:rounded-[.25rem]"
            style={aspectRatio(mastheadImage.filename)}
            loading="lazy"
          />
        </div>
      {/if}
    </div>

    <div
      class="md:flex-auto text-black p-4 pb-12 md:p-0 space-y-[14px] lg:space-y-[16px]"
    >
      {#if displayDate.length > 0}
        <div class="type:h5-eyebrow text-[#000] pb-1 opacity-50">
          {displayDate}
        </div>
      {/if}

      <h3 class="type:h4 flexs-auto text-[#000]">
        {@html heading}
      </h3>
    </div>

    <div class="hidden md:block mt-[1rem] md:mt-[40px]">
      <ArrowLink
        class="reduced hover-red-bg"
        iconClasses={isExternalLink ? "transform -rotate-45" : ""}
        noText={blok?.post?.content?.readMoreButtonTitle?.length === 0}
      >
        {blok?.post?.content?.readMoreButtonTitle || "Read article"}
      </ArrowLink>
    </div>
  </div>

  {#if mastheadImage?.filename?.length > 0}
    <img
      src={resizeImage(mastheadImage.filename, 920, 720)}
      alt={blok.post.name}
      class="hidden md:block md:max-w-[40%] h-full lg:max-w-[50%] max-h-full object-cover flex-auto rounded-[.25rem]"
      style={aspectRatio(mastheadImage.filename)}
      loading="lazy"
    />
  {/if}
</a>
